// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    sendEmailWithSheetApi,
    SendEmailWithSheetApiParameter,
} from "@steiner/App/Services/PipeAndWireSheetPricingServices";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        email?: string;
        message?: string;
    } & HasOnSuccess &
        HasOnError,
    SendEmailWithSheetApiParameter,
    ServiceResult<void>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        email: props.parameter.email,
        message: props.parameter.message,
    };
};

export const CallSendEmailWithSheet: HandlerType = async props => {
    try {
        props.apiResult = await sendEmailWithSheetApi(props.apiParameter);
        props.apiResult.successful = true;
    } catch (error) {
        props.apiResult.successful = false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const chain = [PopulateApiParameter, CallSendEmailWithSheet, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const sendEmailWithSheet = createHandlerChainRunner(chain, "SendEmailWithSheet");
export default sendEmailWithSheet;
